// CHA-11 — État canonique d'un CRC, miroir de backend/services/crc_statuts.py.
// Le backend renvoie `statut_canonique` (GET /meetings, GET /crc/{id}) ; ce
// helper sert de repli pour des données plus anciennes.
import { STATUT_COMPTE_RENDU } from '../../../lib/libelles';

const ALIAS = {
  brouillon: 'brouillon',
  valide: 'valide',
  publie: 'publie',
  diffuse: 'diffuse',
  ENVOYE: 'diffuse',
  envoye: 'diffuse',
  signe: 'signe',
};

// RP04 — libellés du vocabulaire unique (09-VOCABULAIRE §3) : Brouillon → À relire → Diffusé → Accepté.
export const CRC_STATUT_LABELS = {
  brouillon: STATUT_COMPTE_RENDU.brouillon,
  valide: STATUT_COMPTE_RENDU.valide,
  publie: STATUT_COMPTE_RENDU.publie,
  diffuse: STATUT_COMPTE_RENDU.diffuse,
  signe: STATUT_COMPTE_RENDU.signe,
};

export function crcStatut(crc) {
  if (!crc) return 'brouillon';
  if (crc.statut_canonique) return crc.statut_canonique;
  let canon = ALIAS[crc.statut] || 'brouillon';
  if (['brouillon', 'valide', 'publie'].includes(canon) && (crc.diffusion_date || crc.envoye_at)) {
    canon = 'diffuse';
  }
  return canon;
}

// Visible des destinataires (entreprises, clients)
export const crcEstPublie = (crc) => ['publie', 'diffuse', 'signe'].includes(crcStatut(crc));

// Diffusé : contenu verrouillé
export const crcEstVerrouille = (crc) => (crc && crc.verrouille !== undefined
  ? !!crc.verrouille
  : ['diffuse', 'signe'].includes(crcStatut(crc)));
